module.exports = __webpack_public_path__ + "img/code2.2397b9ee.jpg";